import {
    redirect,
    Navigate
  } from "react-router-dom";
import {localStorageUserKey, localStorageAdminKey} from '../local_storage_vars';
import { smartStorage } from "../smart_storage";

const AuthRequired = ({children})=>{
    const user = smartStorage.get(localStorageUserKey);
    if(!user){
        return <Navigate to={'/login'} />
    }else{
        return children
    }
}

export default AuthRequired